import { sanitizePath } from '../../lib/sanitizePath';
import { useLocalStorage } from './useLocalStorage';

export const useLastPath = (defaultValue: string | null = null) => {
  const [lastPath, setLastPath] = useLocalStorage('lastPath', defaultValue);
  return [sanitizePath(lastPath || undefined), setLastPath] as const;
};
